export const dollarsToCents = (dollars) =>
  Number.isFinite(dollars) ? Math.round(dollars * 100) : null;

export const rowFromShop = ({ influencer_id, name, avatar_url }) => ({
  influencerId: influencer_id,
  name,
  avatarUrl: avatar_url,
  amount: null,
  noFulfillment: false,
});

export const toSignerPayload = ({ influencerId, amount, noFulfillment }) => ({
  influencerId,
  splitAmount: dollarsToCents(amount),
  noFulfillment,
});

const hasAmount = ({ amount }) => Number.isFinite(amount) && amount >= 0;

export const canApply = (rows) => rows.length > 0 && rows.every(hasAmount);

export const isZeroSplit = ({ amount }) => amount === 0;

const shopName = (names, influencerId) =>
  names.get(influencerId) ?? `Shop ${influencerId}`;

const PROBLEM_TEXT = {
  "no-payout-cut": (names, { influencerId }) =>
    `${shopName(
      names,
      influencerId,
    )} has no payout cut. Set one up before adding them to products.`,
  "duplicate-signer": (names, { influencerId }) =>
    `${shopName(names, influencerId)} was added more than once.`,
  "unknown-product": (_, { productId }) =>
    `Product ${productId} no longer exists. Refresh and try again.`,
  "archived-product": (_, { productId }) =>
    `Product ${productId} has been deleted. Refresh and try again.`,
};

export const describeProblem = (names) => (problem) =>
  PROBLEM_TEXT[problem.reason](names, problem);

const OUTCOME_GROUP = {
  added: "added",
  reactivated: "added",
  updated: "updated",
  unchanged: "unchanged",
};

const countByGroup = (changes) =>
  changes.reduce(
    (counts, { outcome }) => ({
      ...counts,
      [OUTCOME_GROUP[outcome]]: counts[OUTCOME_GROUP[outcome]] + 1,
    }),
    { added: 0, updated: 0, unchanged: 0 },
  );

const capitalise = (text) => text.charAt(0).toUpperCase() + text.slice(1);

export const summariseChanges = (changes) => {
  const { added, updated, unchanged } = countByGroup(changes);
  const parts = [
    added > 0 ? `added ${added}` : null,
    updated > 0 ? `updated ${updated}` : null,
    unchanged > 0 ? `already set on ${unchanged}` : null,
  ].filter(Boolean);

  return `${capitalise(parts.join(", "))}.`;
};
